import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const WalletWhiteIcon = ({ color = 'text' }: { color?: string }) => {
	return (
		<Icon
			width="21px"
			height="15px"
			viewBox="0 0 21 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.6216 7.68971V7.69971M3.62158 13.6897H17.6216C18.7262 13.6897 19.6216 12.7943 19.6216 11.6897V3.6897C19.6216 2.58513 18.7262 1.6897 17.6216 1.6897H3.62158C2.51701 1.6897 1.62158 2.58513 1.62158 3.6897V11.6897C1.62158 12.7943 2.51701 13.6897 3.62158 13.6897ZM19.6216 4.6897H12.6216C10.9647 4.6897 9.62158 6.03284 9.62158 7.6897C9.62158 9.34655 10.9647 10.6897 12.6216 10.6897H19.6216V4.6897Z"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
